import { SVGProps, Ref, forwardRef } from 'react';

export const IbsBrandSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M29.5 0h-27A2.5 2.5 0 0 0 0 2.5v27A2.5 2.5 0 0 0 2.5 32h27a2.5 2.5 0 0 0 2.5-2.5v-27A2.5 2.5 0 0 0 29.5 0"
                fill="#0022CC"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.527 13.884h.684v4.232h-.684v1.957H9.95v-1.957h-.684v-4.232h.684v-1.957H5.527zm12.16 1.952a1.89 1.89 0 0 0 1.106-1.859c0-1.053-.819-2.042-2.235-2.042h-5.79v1.957h.684v4.224h-.684v1.956h6.183a2.25 2.25 0 0 0 1.515-.72 2.24 2.24 0 0 0 .593-1.567 2.04 2.04 0 0 0-1.38-1.916zm-2.206 2.292h-1.228v-1.226h1.228a.623.623 0 0 1 .614.613.607.607 0 0 1-.618.609zm-1.232-3.076v-1.168h1.179a.594.594 0 0 1 .577.584.604.604 0 0 1-.585.588zm8.153-.173c.11.11.256.173.411.177l1.691-.004a2.51 2.51 0 0 1 2.35 1.521c.13.305.198.632.2.962a2.54 2.54 0 0 1-.745 1.793 2.55 2.55 0 0 1-1.797.744H19.89V17.54h2.538v.6h1.229a.615.615 0 0 0 .614-.613.61.61 0 0 0-.614-.613H21.99a2.46 2.46 0 0 1-2.332-1.496 2.45 2.45 0 0 1-.194-.954c0-1.594 1.245-2.53 2.83-2.53h4.208v2.521h-2.518v-.572h-1.17a.59.59 0 0 0-.586.585.6.6 0 0 0 .174.41"
                fill="white"
            />
        </g>
    </svg>
));
IbsBrandSize32Glyph.displayName = 'IbsBrandSize32Glyph';
